export const ENROLLMENT_STATUS_LABELS = {
  PENDING_REVIEW: "Pending Review",
  AWAITING_PAYMENT: "Awaiting Payment",
  PAYMENT_RECEIVED: "Payment Received",
  APPROVED: "Approved",
  REJECTED: "Rejected",
};

export function normalizeEnrollmentStatus(value) {
  const token = String(value || "")
    .trim()
    .toUpperCase()
    .replace(/\s+/g, "_");
  if (token === "NEW" || token === "PENDING" || token === "PENDING_REVIEW") {
    return "PENDING_REVIEW";
  }
  return token;
}

export function getEnrollmentStatusLabel(value) {
  const token = normalizeEnrollmentStatus(value);
  return ENROLLMENT_STATUS_LABELS[token] || token.replace(/_/g, " ").replace(/\b\w/g, (m) => m.toUpperCase());
}

